module.exports = __webpack_public_path__ + "r-v3/img/screen_on.3a472e76.svg";